import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// We'll initialize Preline in App.jsx instead

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);